import styled from "styled-components";

export const Container = styled.div`
  background: ${(props) => props.theme.background.default};

  .container {
    margin: 0 auto;
    max-width: 1080px;
    padding: 100px 0 100px;

    .title-main {
      text-transform: uppercase;
      font-family: "DM Sans";
      font-weight: 700;
      font-size: 24px;
      color: ${(props) => props.theme.color.default};
      margin-bottom: 20px;
      @media (max-width: 1024px) {
        padding: 0 25px;
      }
      /* @media (max-width: 768px) {
        padding: 0 25px;
        margin-bottom: 50px;
        font-size: 25px;
      } */
    }

    .wp-slider {
      max-width: 650px;
      margin-left: auto;
      position: relative;
      margin-right: 45px;
      @media (max-width: 1366px) {
        margin-right: 50px;
      }
      @media (max-width: 900px) {
        margin: 0 auto 34px;
        max-width: 450px;
      }
      @media (max-width: 575px) {
        max-width: 298px;
      }
      @media (max-width: 375px) {
        max-width: 250px;
      }

      .btn-next {
        position: absolute;
        right: -46px;
        top: 50%;
        transform: translateY(-50%);
        @media (max-width: 425px) {
          right: -35px;
        }
        @media (max-width: 280px) {
          right: -15px;
        }
      }
      .btn-prev {
        position: absolute;
        left: -46px;
        top: 50%;
        transform: translateY(-50%);
        @media (max-width: 425px) {
          left: -35px;
        }
        @media (max-width: 280px) {
          left: -15px;
        }
      }

      .slick-slide {
        > div {
          margin: 0 10px;
          @media (max-width: 280px) {
            margin: 0 3px;
          }
        }
      }

      .item-slider {
        display: inline-block;
        height: 40px;
        border: 1px solid ${(props) => props.theme.color.default};
        border-radius: 40px;
        line-height: 40px;
        text-align: center;

        letter-spacing: 0.1px;
        font-family: "Noto Sans KR";
        font-weight: 400;
        font-size: 16px;
        color: ${(props) => props.theme.color.default};
        cursor: pointer;
        @media (max-width: 575px) {
          font-size: 11.777px;
          height: 30px;
          line-height: 30px;
        }

        &__active {
          font-family: "Noto Sans KR Bold";
          background: #e6faf8;
          border: 1px solid ${(props) => props.theme.color.active};
          letter-spacing: 0.1px;
          font-weight: 500;
          color: ${(props) => props.theme.color.active};
        }
      }
    }

    .box-content {
      margin-top: 30px;
      .box {
        background: rgba(221, 221, 221, 0.38);
        margin: 6px 0;
        padding: 30px 30px 28px;
        display: block;
        @media (max-width: 768px) {
          padding: 17px;
          margin: 12px 0;
          background-color: #fcfaf5;
          border-bottom: 1px solid ${(props) => props.theme.color.opacity};
        }

        .box-title {
          margin-bottom: 10px;
          display: flex;

          .title {
            color: ${(props) => props.theme.color.active};
            font-family: "Noto Sans KR";
            font-weight: 700;
            font-size: 17px;
            padding-right: 20px;
            @media (max-width: 768px) {
              font-size: 13px;
            }
          }
          .date {
            color: ${(props) => props.theme.color.default};
            font-family: "Noto Sans KR";
            font-weight: 400;
            font-size: 17px;
            @media (max-width: 768px) {
              color: ${(props) => props.theme.color.opacity};
              font-size: 13px;
            }
          }
        }

        .content {
          color: ${(props) => props.theme.color.default};
          font-family: "Noto Sans KR";
          font-weight: 400;
          font-size: 22px;
          @media (max-width: 768px) {
            font-size: 16px;
          }
        }
      }
    }

    .see-more {
      margin-top: 80px;
      text-align: center;
      display: inline-block;
      position: relative;
      transform: translateX(-50%);
      top: 0;
      left: 50%;
      cursor: pointer;
      @media (max-width: 768px) {
        margin-top: 30px;

        > img {
          max-width: 50px;
          object-fit: cover;
        }
      }

      .text {
        margin-bottom: 30px;
        text-transform: uppercase;
        font-family: "Noto Sans KR";
        font-weight: 700;
        font-size: 15px;
        color: ${(props) => props.theme.color.opacity};
        @media (max-width: 768px) {
          font-size: 13px;
          margin-bottom: 10px;
        }
      }
    }
  }
`;
